let id = 0;
export const getNextId = (): number => {
  id += 1;
  return id;
};
